/**
 * 主題功能配置
 * 每個主題都明確配置自己的功能
 * 未列出的功能一律視為關閉（hasFeature 回傳 false、themeConfig.xxx 為 undefined）
 *
 * 新主題開站預設關閉（新增主題時以下設為 false，待確認後再開）：
 * - showMemberTerms：註冊彈窗的利用規約連結
 * - showFooter：整個頁腳（關閉時其餘 showFooter* 不作用）
 * - showSupportCenter：側欄サポート（/page/support），手機底部サポート同步
 * - showBlog：側欄ブログ
 * - showSocialMediaTitle：側欄 SNS 區塊標題文字（公式SNS），icon 仍依 showSocialMedia
 * - showDepositGuide：入金ガイド入口
 * - showWithdrawalDesc：出金ガイド入口
 */

const themeFeatures = {
  theme_gold: {
    showChatBox: true,
    showSupportCenter: true,
    showMemberTerms: true,
    showBlog: true,
    showEvent: true,
    showBankCreate: true,
    showUserLetter: false,
    showNews: true,
    showSupMenu: true,
    showFooter: true,
    showFooterText: true,
    showFollowUs: true,
    showSocialMedia: true,
    showSocialMediaTitle: true,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: true,
    showFooterIntro: true,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: true,
    showWithdrawalDesc: true,
    showVipContent: true,
    showPayTypeList: true,
    showPersonalAd: true,
    showFavoriteImage: false,
    showNavLogoPlate: true, // 側欄 logo 圓形底盤（切版僅 gold 的牌記 logo 使用，其他主題顯示原圖）
    vipMembershipCard: true // VIP 會員卡版型：v2 區塊以 vip2 會員卡呈現（圖片＋名稱、升格條件、特典）
  },
  theme_blue: {
    showChatBox: true,
    showSupportCenter: false,
    showMemberTerms: false,
    showBlog: false,
    showEvent: true,
    showBankCreate: true,
    showUserLetter: false,
    showNews: true,
    showSupMenu: true,
    showFooter: true,
    showFooterText: false,
    showFollowUs: false,
    showSocialMedia: true,
    showSocialMediaTitle: true,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: true,
    showFooterIntro: false,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: false,
    showWithdrawalDesc: false,
    showVipContent: true,
    showPayTypeList: false,
    showPersonalAd: false,
    showFavoriteImage: false,
    showNavLogoPlate: false,
    vipMembershipCard: false
  },
  theme_purple: {
    showChatBox: true,
    showSupportCenter: false,
    showMemberTerms: true,
    showBlog: false,
    showEvent: false,
    showBankCreate: false,
    showUserLetter: false,
    showNews: false,
    showSupMenu: false,
    showFooter: true,
    showFooterText: false,
    showFollowUs: false,
    showSocialMedia: true,
    showSocialMediaTitle: true,
    showFooterBank: false,
    showFooterProviders: false,
    showFooterLicense: false,
    showFooterIntro: false,
    showFooterResponsible: false,
    showFooterHelpCenter: false,
    showDepositGuide: false,
    showWithdrawalDesc: false,
    showVipContent: false,
    showPayTypeList: true,
    showPersonalAd: true,
    showFavoriteImage: false,
    showNavLogoPlate: false,
    vipMembershipCard: false
  },
  theme_cb168: {
    showChatBox: false,
    showSupportCenter: false,
    showMemberTerms: false,
    showBlog: false,
    showEvent: false,
    showBankCreate: true,
    showUserLetter: false,
    showNews: true,
    showSupMenu: true,
    showFooter: false,
    showFooterText: true,
    showFollowUs: true,
    showSocialMedia: false,
    showSocialMediaTitle: false,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: true,
    showFooterIntro: true,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: false,
    showWithdrawalDesc: false,
    showVipContent: true,
    showPayTypeList: true,
    showPersonalAd: false,
    showFavoriteImage: false,
    showNavLogoPlate: false,
    vipMembershipCard: false
  },
  theme_tiger: {
    showChatBox: true,
    showSupportCenter: true,
    showMemberTerms: true,
    showBlog: false,
    showEvent: true,
    showBankCreate: false,
    showUserLetter: false,
    showNews: true,
    showSupMenu: true,
    showFooter: true,
    showFooterText: true,
    showFollowUs: false,
    showSocialMedia: false,
    showSocialMediaTitle: false,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: false,
    showFooterIntro: false,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: false,
    showWithdrawalDesc: false,
    showVipContent: true,
    showPayTypeList: false,
    showPersonalAd: false,
    showFavoriteImage: true, // 我的最愛分類鈕改用主題圖 favorite.png（彩色圖，不套用線框 icon）
    showNavLogoPlate: false,
    vipMembershipCard: false
  },
  theme_neotri: {
    showChatBox: true,
    showSupportCenter: false,
    showMemberTerms: false,
    showBlog: false,
    showEvent: true,
    showBankCreate: true,
    showUserLetter: false,
    showNews: true,
    showSupMenu: true,
    showFooter: true,
    showFooterText: false,
    showFollowUs: false,
    showSocialMedia: true,
    showSocialMediaTitle: true,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: false,
    showFooterIntro: false,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: false,
    showWithdrawalDesc: false,
    showVipContent: true,
    showPayTypeList: false,
    showPersonalAd: false,
    showFavoriteImage: false,
    showNavLogoPlate: false,
    vipMembershipCard: false
  },
  theme_momo: {
    showChatBox: true,
    showSupportCenter: false,
    showMemberTerms: true,
    showBlog: false,
    showEvent: true,
    showBankCreate: true,
    showUserLetter: false,
    showNews: true,
    showSupMenu: true,
    showFooter: false,
    showFooterText: true,
    showFollowUs: true,
    showSocialMedia: true,
    showSocialMediaTitle: false,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: false,
    showFooterIntro: false,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: true,
    showWithdrawalDesc: true,
    showVipContent: true,
    showPayTypeList: true,
    showPersonalAd: true,
    showFavoriteImage: false,
    showNavLogoPlate: false,
    vipMembershipCard: false
  }
}

/**
 * 獲取當前主題的完整配置
 */
export function getCurrentThemeConfig() {
  const currentTheme = process.env.VUE_APP_THEME || 'theme_gold'
  const config = themeFeatures[currentTheme]

  if (!config) {
    console.error(`未找到主題配置: ${currentTheme}`)
    return {}
  }

  return config
}

/**
 * 檢查當前主題是否啟用某功能
 */
export function hasFeature(featureName) {
  const config = getCurrentThemeConfig()
  return config[featureName] ?? false
}

/**
 * 獲取當前主題名稱
 */
export function getCurrentTheme() {
  return process.env.VUE_APP_THEME || 'theme_gold'
}

export default {
  getCurrentThemeConfig,
  hasFeature,
  getCurrentTheme
}
